module.exports = __webpack_public_path__ + "img/logo-13.64c81f6.jpg";